<script setup>
import { useFlagStore } from '@/store';
import { useRouter } from 'vue-router';
import InputField from '@/components/InputField.vue';
import { ref, computed, onMounted } from 'vue';
defineOptions({
  name: 'JoinGamePage',
});
const playerName = ref('');
const store = useFlagStore();
const router = useRouter();
playerName.value = store.getLastPlayerName;

const selectedDifficultyId = ref(0);
const selectedLangId = ref('nl');
if (store.getCurrentLanguageId) {
  selectedLangId.value = store.getCurrentLanguageId;
} else {
  selectedLangId.value = 'nl';
}
const gameUrlName = store.getGameUrlName;

const join = async () => {
  try {
    await store.initAudio(selectedLangId.value);
  } catch (err) {
    const errStr = store.getErrorMessage(err);
    store.setModal({
      content: 'microphone trouble:' + errStr,
      title: 'error',
      eventName: '',
      type: 'notification',
    });
    return;
  }
  store.joinExistingGame({
    playerName: playerName.value,
    languageId: selectedLangId.value,
    difficultyId: selectedDifficultyId.value,
    gameName: gameUrlName,
  });
};
const totalPlayersOnline = computed(() => store.totalPlayersOnline);

onMounted(() => {
  if (store.getGameUrlName == '') {
    router.push({ name: 'HomePage' });
  }
});
</script>
<template>
  <div>
    <h1 class="title strong">Talk to the flag!</h1>
    <h2>join a game</h2>
    <InputField
      v-model="playerName"
      :id="'playerName'"
      :placeholder="store.getLabel('placeholder')"
      :default-value="playerName"
      :aria-label="'playerName'"
    ></InputField>
  </div>
  <div>
    <div class="radio-group">
      <label class="radio-label">
        <input
          type="radio"
          value="en"
          v-model="selectedLangId"
          name="language"
        />
        english
      </label>
      <label class="radio-label">
        <input
          type="radio"
          value="nl"
          v-model="selectedLangId"
          name="language"
        />
        nederlands
      </label>
    </div>
  </div>
  <div>
    <button class="button" :disabled="playerName == ''" @click="join">
      {{ store.getLabel('join') }} {{ gameUrlName }}
    </button>
  </div>
  <p>{{ store.getLabel('online') }} {{ totalPlayersOnline }}</p>
</template>

<style scoped></style>
